<template>
    <el-select :value="valueId" :clearable="clearable" @clear="clearHandle" :placeholder="$t('common.selectA')">
        <el-option :value="valueId" :label="valueTitle">
          <el-tree id="tree-option"
                   ref="selectTree"
                   :accordion="accordion"
                   :data="options"
                   :props="props"
                   :node-key="props.value"
                   @node-click="handleNodeClick">
            <span slot-scope="{ node, data }"
                  class="el-tree-node__label">{{ data.entity.organization.organizationLanguages[0].name }}</span>
          </el-tree>
        </el-option>
    </el-select>
</template>
<script>
    export default {
        name: 'OrgSelect',
        props: {
            /* 配置项 */
            props: {
                type: Object,
                default: () => {
                    return {
                        value: 'id',
                        label: 'name',
                        children: 'children'
                    };
                }
            },
            /* 选项列表数据(树形结构的对象数组) */
            options: {
                type: Array,
                default: () => { return []; }
            },
            /* 初始值 */
            value: {
                type: String,
                default: () => { return ''; }
            },
            /* 可清空选项 */
            clearable: {
                type: Boolean,
                default: () => { return true; }
            },
            /* 自动收起 */
            accordion: {
                type: Boolean,
                default: () => { return true; }
            },
        },
        data() {
            return {
                valueId: this.value,
                valueTitle: '',
            };
        },
        methods: {
            // 切换选项
            handleNodeClick(node) {
                this.valueTitle = node.entity.organization.organizationLanguages[0].name;
                this.valueId = node.entity.organization.code;
              this.$emit('getValue', this.valueId);
              this.$emit('input', this.valueId);
            },
            // 清除选中
            clearHandle() {
                this.valueTitle = '';
                this.valueId = null;
                this.clearSelected();
              this.$emit('getValue', null);
              this.$emit('input', null);
            },
            /* 清空选中样式 */
            clearSelected() {
                const allNode = document.querySelectorAll('#tree-option .el-tree-node');
                allNode.forEach((element) => element.classList.remove('is-current'));
            },
            getSelectData() {
                if (this.valueId == null) {
                    return null;
                }
                return {value: this.valueId, label: this.valueTitle};
            }
        },
        watch: {
            value() {
                this.valueId = this.value;
            }
        },
    };
</script>

<style scoped>
    .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
        height: auto;
        max-height: 274px;
        padding: 0;
        overflow: hidden;
        overflow-y: auto;
    }
    .el-select-dropdown__item.selected{
        font-weight: normal;
    }
    ul li >>>.el-tree .el-tree-node__content{
        height:auto;
        padding: 0 20px;
    }
    .el-tree-node__label{
        font-weight: normal;
    }
    .el-tree >>>.is-current .el-tree-node__label{
        color: #409EFF;
        font-weight: 700;
    }
    .el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{
        color:#606266;
        font-weight: normal;
    }
</style>

